export default __webpack_public_path__ + "img/logo-zdy.864a35ab.png";